export enum smsFormats {
    link = 'link',
    text = 'text',
}
